module.exports = __webpack_public_path__ + "avatar-2.12f790adb99e408d7d76.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/GKool/source/repos/e2epublicwebsite/src/assets/images/avatar/avatar-2.png
// module id = ../../../../../src/assets/images/avatar/avatar-2.png
// module chunks = 0